import React, { useState } from 'react'
import { IconButton, Button, TextField, InputAdornment } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import styles from './ChangePasswordForm.module.scss'

const ChangePasswordComponent = (props) => {
    const [ password , setPassword ] = useState('')
    const [ password2 , setPassword2 ] = useState('')
    const [showPassword1, setShowPassword1] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)

    const sendPassword = (e) => {
        props.submitForm(e, password, password2)
        setPassword('')
        setPassword2('')
    }

    const handleClickShowPassword = (e) => {
        const currentId = e.currentTarget.parentElement.parentElement.firstChild.id
        if (currentId[currentId.length - 1] === '1') {
            setShowPassword1(!showPassword1) 
        } else {
            setShowPassword2(!showPassword2) 
        }
    }

    return (
        <form className={styles['form']} onSubmit={(e) => sendPassword(e)} >
            <TextField
                className={styles['text-field']}
                id="outlined-adornment-password1"
                type={showPassword1 ? 'text' : 'password'}
                value={password}
                placeholder={props.input1PlaceHolder}
                variant="outlined"
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                    endAdornment:
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) => handleClickShowPassword(e)}
                                edge="end"
                            >
                                {showPassword1 ?<Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        </InputAdornment>
                }}
            /> 
            <TextField
                className={styles['text-field']}
                id="outlined-adornment-password2"
                type={showPassword2 ? 'text' : 'password'}
                value={password2}
                placeholder={props.input2PlaceHolder}
                variant="outlined"
                onChange={(e) => setPassword2(e.target.value)}
                InputProps={{
                    endAdornment:
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) => handleClickShowPassword(e)}
                                edge="end"
                            >
                                {showPassword2 ? <Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        </InputAdornment>
                }}
            /> 
            <Button size="large" type="submit" value="Submit" variant="contained" color="primary">
                {props.ButtonPlaceHolder}
            </Button>
        </form>
    )
}

export default ChangePasswordComponent
